import { render, staticRenderFns } from "./ModrAddMtrl.vue?vue&type=template&id=e1a9c644&scoped=true&"
import script from "./ModrAddMtrl.vue?vue&type=script&lang=js&"
export * from "./ModrAddMtrl.vue?vue&type=script&lang=js&"
import style0 from "./ModrAddMtrl.vue?vue&type=style&index=0&id=e1a9c644&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a9c644",
  null
  
)

export default component.exports